
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';
import React from 'react'

const ConfirmDialog = ({openDialog, setOpenDialog, deleteRow, handleResponse}) => {

    const handleClose = (opcion) => {
        //console.log(opcion);
        handleResponse(opcion);
        setOpenDialog(false);
    };

    return (
        <Dialog
            open={openDialog}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {"Confirmar acción"}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <Typography component={'p'}>
                        Por favor confirmar que desea borrar el producto:
                    </Typography>
                    <ul>
                        <li>{deleteRow.product}</li>
                        <li>ID: {deleteRow.id}</li> 
                    </ul>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={() => handleClose('canelar')}>Cancelar</Button>
                <Button variant='contained' onClick={() => handleClose('borrar')} autoFocus>
                    Borrar Registro
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmDialog